import React from 'react'
import HttpServices from '../../../utils/Http.services'
import { checkTextTranslation, imageAddress, translate } from '../../../utils/useful'


class AddWidgets extends React.Component {
    state = {
        singleWidgets: [

            { img: '/assets/images/BingWallpaper.jpg', name: "Widgets-1", size: 'small', description: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.' },

        ]
    }

    componentDidMount() {
        let widget = this.props.initData.widget
        console.log('this in widget', widget)
        let widgetKey = this.props.initData.widgetKey
        console.log('this in widgetKey', widgetKey)
        let foundType
        widget.types.forEach(type => {
            if (type.key == widgetKey) {
                foundType = type
            }
        });

        this.setState({ type: foundType }, () => {
            console.log(this.state.type)
        })
    }

    render() {
        return (
            <div className="w-100 h-100 scroll-no-scrollbar">

                <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc' }}>
                    <div className="mb-1">
                        <button onClick={() => this.props.lastStage()} className='flexc'>
                            <div className='rotate-180 br-50 ws-25 hs-25 flexcc' style={{ background: '#ffffffcd' }}>
                                <img className='' src="/assets/icons/useful/angle-right.svg" height={20} />
                            </div>
                            <h2 style={{ color: '#ffffffcc', fontSize: 18 }} className="  mx-2" >{translate('Select Widgets')}</h2>
                        </button>
                    </div>
                    {/* <div >
                                            <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                                                <input className="py-1 px-2 w-100" placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                                            </div>
                                        </div> */}
                </div>
                <div className="w-100 mt-2 flexcc flex-column" >
                    <div className="w-100 " style={{ maxWidth: '300px' }}>
                        {/* {Object.values(this.state.type).map((prop) => {
                        return ( */}
                        {console.log('this.props.initData.applet', this.props.initData.applet)}
                        <div className="flexcb my-3">
                            <div className="flexcc ">
                                <div className='flexcc mrd-3'>
                                    {/* <img src={this.props.initData.applet.img} style={{ borderRadius: 11 }} width='250px' /> */}
                                    <img className="br-50" src={imageAddress(this.props.initData.applet?.image)} style={{ width: '45px', height: 45, }} />

                                </div>
                                <div className="">
                                    <p className="text-normal">{checkTextTranslation(this.props.initData.applet.applet.name)}</p>
                                    <p className="text-smaller">{checkTextTranslation(this.props.initData.applet.appletHub.fullname)}</p>
                                </div>

                            </div>
                            <div className="flexcc ">
                                <p className=" text-normal" style={{ fontSize: 16, fontWeight: "600" }}>{this.props.initData.widget.title}</p>
                            </div>
                        </div>
                        <div className="flexcc mb-4 flex-column">
                            <div>
                                <div className="flexcc mt-2">
                                    <img src={this.state.type?.img} style={{ borderRadius: 11 }} width='300px' />
                                </div>

                                <div className="flexcc flex-column">
                                    <div>
                                        {/* <p className="mt-2" style={{ fontSize: 16, fontWeight: "600" }}>{this.state.type?.name}</p> */}
                                        <p className="mt-2" style={{ fontSize: 16, fontWeight: "600" }}>{this.state.type?.name}</p>
                                    </div>
                                    {/* <div>
                                                                <p className="mt-2" style={{ fontSize: 11 }}>{this.state.type.size}</p>
                                                            </div> */}
                                    {/* <div>
                                            <p className="mt-3 des-color text-center" style={{ fontSize: 13, maxWidth: "300px" }}>{this.state.type.description}</p>
                                        </div> */}
                                </div>

                            </div>
                            <button className="flexcb mt-4 p-1" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', borderRadius: 9 }}>
                                <div className="mrd-1 default-btn-icon">
                                    <p style={{ color: '#fff', padding: '3px 9px' }}>+</p>
                                </div>
                                <div className="px-3" style={{}}>
                                    <p style={{ color: '#fff' }}>{translate('Add Widget')}</p>
                                </div>
                            </button>
                        </div>
                        {/* )
                    })} */}
                    </div>
                </div>
            </div>

        );
    }
}

export default AddWidgets;